
<div [matTooltip]="statut?.libelle" class="container" [ngClass]="{ 'minimized': isMinimized }" [attr.aria-label]="statut?.libelle">
    <div class="row">
        <div *ngFor="let color of colors" class="col block" [class]="color" [class.long]="colors.length == 4">&nbsp;</div>
    </div>
</div>